import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Ist Ofri wirklich kostenlos?',
    answer: 'Ja, für Sie als Kunde ist Ofri zu 100% kostenlos. Wir berechnen nichts für die Vermittlung oder die Offerten. Sie zahlen nur, wenn Sie sich für einen Maler entscheiden und dieser die Arbeit ausführt.'
  }, {
    question: 'Wie schnell erhalte ich Offerten?',
    answer: 'In der Regel innerhalb von 24 Stunden, oft schon nach wenigen Stunden. Die Malerfirmen in Ihrer Region werden automatisch über Ihr Projekt informiert und melden sich direkt bei Ihnen.'
  }, {
    question: 'Sind die Maler auf Ofri geprüft?',
    answer: 'Ja, wir überprüfen jede Firma manuell vor der Aufnahme in unser Netzwerk. Zusätzlich sehen Sie echte Kundenbewertungen von früheren Projekten, damit Sie eine informierte Entscheidung treffen können.'
  }, {
    question: 'Bin ich zu etwas verpflichtet?',
    answer: 'Nein, absolut nicht. Sie erhalten kostenlose Offerten und können diese in Ruhe vergleichen. Wenn Ihnen keine Offerte zusagt, müssen Sie keine annehmen. Es gibt keine versteckten Kosten oder Verpflichtungen.'
  }, {
    question: 'Welche Malerarbeiten kann ich ausschreiben?',
    answer: 'Sie können alle Arten von Malerarbeiten ausschreiben: Innen- und Aussenanstriche, Tapezierarbeiten, Verputzarbeiten, Fassadenarbeiten sowie komplette Renovationen. Unsere Maler decken das gesamte Spektrum ab.'
  }];
  return <section className="py-14 sm:py-20 bg-white" data-id="element-88">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 sm:mb-16" data-id="element-90">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-91">
            Häufig gestellte Fragen
          </h2>
          <p className="text-base sm:text-xl text-gray-600" data-id="element-92">
            Alles, was Sie über Ofri wissen müssen
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-93">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-94">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors text-left" data-id="element-95">
                <span className="font-semibold text-gray-900 pr-4" data-id="element-96">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-97" />
              </button>

              <AnimatePresence data-id="element-98">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-99">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-100">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}